module.exports = __webpack_public_path__ + "static/media/view4.edb8b267.jpg";